import { useRouter } from 'next/router'

import { BCKSInvitationFinal } from 'app/BCKSPage/Invitation/final'
import { useQueryAPIGetKSSelectionCandidate } from 'api/bcks/useAPIBCKSInvitation'
import { SELECTION_STATES_FINAL_PAGE } from 'app/BCKSPage/constants'
import { isToggleEnabled } from 'configs/toggle-feature'
import MaintenanceModePage from 'app/BCKSPage/MaintenanceMode'

interface PropsInvitationDocumentReviewPage {
  isKSSelectionEnabled: boolean
}

export const getServerSideProps = async () => {
  const isKSSelectionEnabled = await isToggleEnabled('ks-selection-enabled')

  return {
    props: {
      isKSSelectionEnabled,
    },
  }
}

const BCKSInvitationFinalPage = (props: PropsInvitationDocumentReviewPage) => {
  const router = useRouter()
  const { data: selectionState } = useQueryAPIGetKSSelectionCandidate({
    useErrorBoundary: true,
  })

  if (!props.isKSSelectionEnabled) {
    return <MaintenanceModePage />
  }

  if (
    selectionState &&
    !SELECTION_STATES_FINAL_PAGE.includes(
      selectionState?.selectionCandidateState
    )
  ) {
    router.replace('/home')
  }
  return <BCKSInvitationFinal />
}

// eslint-disable-next-line react/display-name
BCKSInvitationFinalPage.Layout = ({ children }) => children

export default BCKSInvitationFinalPage
